<template lang="pug">
b-modal#selectorModal.modal.fade(
  centered,
  hide-footer="",
  title="PCAP IC Selector",
  tabindex="-1",
  aria-labelledby="selectorModal",
  aria-hidden="true"
)
  p
    small find your IC and thickness of cover glass fitting your system
  form
    .form-group
      label(for="inputPanelSize")
        | Panel Size
        font-awesome-icon.ml-1(
          v-b-tooltip.hover.right="indexInformation.panel_size_desc",
          :icon="['fas', 'exclamation-circle']"
        ) 
      input#inputPanelSize.form-control(type="text", placeholder="inches")
    .form-row
      .form-group.col-md-6
        label(for="inputTx")
          | Active Area X-axis
          font-awesome-icon.ml-1(
            v-b-tooltip.hover.right="indexInformation.active_area_tx_desc",
            :icon="['fas', 'exclamation-circle']"
          )
        input#inputTx.form-control(type="text", placeholder="Area Diameter")
      .form-group.col-md-6
        label(for="inputRx") Active Area Y-axis
        input#inputRx.form-control(type="text", placeholder="Area Diameter")
    .form-row
      .form-group.col-md-6
        label(for="inputTx2")
          | Sensing Channels X-axis
          font-awesome-icon.ml-1(
            v-b-tooltip.hover.right="indexInformation.channels_tx_desc",
            :icon="['fas', 'exclamation-circle']"
          )
        input#inputTx2.form-control(type="text", placeholder="lines")
      .form-group.col-md-6
        label(for="inputRx2") Sensing Channels Y-axis
        input#inputRx2.form-control(type="text", placeholder="lines")
    b-button.btn.btn-primary.btn-block(type="submit") Select
</template>

<script>
import { getIndexInformation } from "@/api/index";

export default {
  name: "DialogSelector",
  data() {
    return {
      indexInformation: {},
    };
  },
  watch: {
    "$store.state.user.language"() {
      this.initialLanguage();
    },
  },
  created() {
    this.initialLanguage();
  },
  methods: {
    initialLanguage() {
      this.getIndexInformation();
    },
    getIndexInformation() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getIndexInformation(temp).then((response) => {
        this.indexInformation = response.data;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.btn-primary {
  background-color: #082b6b;
  border-color: #082b6b;

  &:hover {
    color: #fff;
    background-color: #0069d9;
    border-color: #0062cc;
  }
}

@media only screen and (max-width: 767px) {
  ::v-deep h5 {
    font-weight: 300 !important;
  }
}
</style>
